var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMuteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "3600pt",
    height: "3600pt",
    viewBox: "0 0 3600 3600",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m198.97 287.03c-57.961-57.961 30.098-146.02 88.055-88.055l943.92 943.92h286.88l783.07-783.11c105.59-105.59 285.59-29.699 285.59 118.3v953.5c77.832 13.246 147.74 50.832 201.56 104.58l0.10937-0.10938c150.55 150.55 140.94 400.82-0.10937 527.8l0.10937 0.10938c-53.746 53.746-123.7 91.297-201.67 104.51v329.98l814.54 814.54c57.961 57.961-30.098 146.02-88.055 88.055l-726.52-726.48v447.38c0 148-180 223.88-285.59 118.3l-783.07-783.07h-641.59c-92.195 0-167.29-75.133-167.29-167.29v-979.67c0-92.195 75.098-167.29 167.29-167.29h178.63zm2387.5 1271.7v482.4c43.598-11.34 82.656-34.273 113.65-65.27l0.10938 0.10938c97.488-97.633 97.488-254.3-0.10938-351.94l0.10938-0.10938c-35.605-32-64.082-52.34-113.76-65.191zm-1231-291.35 1106.5 1106.5v-1895.8c0-39.312-46.152-57.059-72.973-30.238l-800.28 800.28c-11.34 11.879-27.359 19.297-45.07 19.297zm1106.5 1282.6-1282.5-1282.6h-303.19c-23.473 0-42.73 19.262-42.73 42.73v979.63c0 23.473 19.262 42.73 42.73 42.73l667.37 0.035157c15.949 0 31.859 6.0859 44.027 18.215l801.36 801.36c26.82 26.82 72.973 9.0703 72.973-30.238z",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuteIcon);
export default __webpack_public_path__ + "static/media/muteIcon.8c893873d34e6777c9fb39c604d338ca.svg";
export { ForwardRef as ReactComponent };